<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="getFactoryImportTable(1)">
                    <multiselect
                        v-model="search.factory"
                        class="form-control select border-0"
                        placeholder="ค้นหาสินค้าโรงงาน"
                        :options="optionFactory"
                        :show-labels="false"
                        :customLabel="factoryLabel"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-model="search.employee"
                        class="form-control select border-0"
                        placeholder="ค้นหาพนักงาน"
                        :options="optionEmployee"
                        :show-labels="false"
                        :customLabel="employeeLabel"
                        multiple=""
                        track-by="id">
                    </multiselect>
                    <date-picker v-model="search.date"
                                 placeholder="วันที่นำออก"
                                 :format="changeFormat"
                                 range
                                 confirm
                                 :lang="lang">
                    </date-picker>&nbsp;
                    <button @click="getFactoryImportTable(1)"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button @click="pdf"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        PDF
                    </button>
                    &nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนสินค้านำเข้า</th>
                    <th scope="col">วัน/เวลา ที่นำเข้า</th>
                    <th scope="col">ผู้นำเข้า</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factoryImportTable">
                    <td class="text-left">
                        {{ data.employee ? data.employee.employee_no + ' - ' + data.employee.name : '' }}
                    </td>
                    <td>{{ data.factory ? data.factory.code + '-' + data.factory.name : '' }}</td>
                    <td>{{ data.quantity }}</td>
                    <td>
                        <template v-if="data.date">
                            {{ data.date | moment('DD/MM/YYYY') }}
                        </template>
                    </td>
                    <td>{{ data.user ? data.user.name : '-' }}</td>
                    <td v-if="!data.status">
                        <span v-if="canViewSuperAdmin" style="text-decoration: underline;color: red;cursor:pointer;"
                              @click="accept(data.id)">อนุมัติ</span>
                        <span v-else style="text-decoration: underline;color: red;cursor:pointer;">อนุมัติ</span>
                    </td>
                    <td v-else>{{ data.user_status ? data.user_status.name : '-' }}</td>
                    <td>
                        <a @click="getFactoryImportById(data.id)">
                            <icon name="pencil-alt"></icon>&nbsp;&nbsp;
                        </a>
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getFactoryImportTable(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal hide-footer hide-header ref="import_item">
            <factory-import-modal @submit="ImportFactoryItem">
            </factory-import-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-confirm-modal @submit="deleteImportFactoryData"></delete-confirm-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import VuePagination from "../Pagination";
import Loading from "../Utility/Loading";
import DeleteConfirmModal from "../Utility/DeleteConfirmModal";
import FactoryImportModal from "./FactoryImportModal";
import Multiselect from "vue-multiselect";
import {canViewSuperAdmin} from "../../util/Permissions";
import {mapState} from "vuex";
import {domain} from "@/util/Constants";

export default {
    name: "import-factory-product",
    components: {
        FactoryImportModal,
        DeleteConfirmModal,
        Loading,
        VuePagination,
        DatePicker,
        Multiselect
    },
    data() {
        return {
            msg: '',
            status_loading: 1,
            delete_id: '',
            optionFactory: [],
            optionEmployee: [],
            search: {
                factory: '',
                date: [],
                employee: [],
            },
            factoryImportTable: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/' + year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.getFactoryImportTable(1);
        this.getFactoryEmployeeAll();
        this.getEmployeeAll();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        pdf() {
            let id = '';
            this.search.employee.forEach((x, i) => {
                id += i >= this.search.employee.length - 1 ? x.id : x.id + ','
            })
            let data = {
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format('YYYY-MM-DD') : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format('YYYY-MM-DD') : '',
                factory_id: this.search.factory ? this.search.factory.id : '',
                employee_id: id,
                pdf: true
            };
            window.open(domain + `/factory_employee_import?` +
                `factory_id=${data.factory_id}` +
                `&start_date=${data.start_date}` +
                `&end_date=${data.end_date}` +
                `&employee_id=${data.employee_id}` +
                `&user=${this.user.id}` +
                `&pdf=${data.pdf}`, '_blank')
            // this.$store.dispatch("FactoryEmployeeImport/getFactoryEmployeeImport", {
            //     page:1,
            //     data,
            // }).then(res => {
            //
            // });
        },
        accept(id) {
            this.showLoadingModal()
            let data = {
                id: id,
                user_id: this.user.id
            }
            this.$store.dispatch('FactoryEmployeeImport/accept', data).then(() => {
                this.getFactoryImportTable(this.dataPaginate.current_page)
            })
        },
        factoryLabel(option) {
            return `${option.code} - ${option.name}`
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        getFactoryEmployeeAll() {
            this.$store.dispatch('FactoryEmployee/getFactoryEmployeeAll').then(res => {
                this.optionFactory = res;
            })
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                this.optionEmployee = res;
            })
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        showImportItemModal() {
            this.$refs.import_item.show();
        },
        hideImportItemModal() {
            this.$refs.import_item.hide();
        },
        getFactoryImportTable(page) {
            let id = '';
            this.search.employee.forEach((x, i) => {
                id += i >= this.search.employee.length - 1 ? x.id : x.id + ','
            })
            let data = {
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format('YYYY-MM-DD') : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format('YYYY-MM-DD') : '',
                factory_id: this.search.factory ? this.search.factory.id : '',
                employee_id: id,
                pdf: false
            };
            this.$store.dispatch("FactoryEmployeeImport/getFactoryEmployeeImport", {
                page,
                data,
            }).then(res => {
                this.factoryImportTable = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
                this.hideLoadingModal();
            });
        },
        getFactoryImportById(id) {
            this.msg = 'กรุณารอสักครู่';
            this.status_loading = 1;
            this.showLoadingModal();
            this.$store.dispatch("FactoryEmployeeImport/showFactoryEmployeeImport", id).then(res => {
                if (res) {
                    this.$store.dispatch("FactoryEmployeeImport/setFormFactoryEmployeeImport", res).then(() => {
                        this.hideLoadingModal();
                        this.showImportItemModal();
                    })
                } else {
                    this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                    this.status_loading = 3;
                    this.showLoadingModal();
                }
            }).catch(() => {
                this.msg = 'ดาวโหลดข้อมูลไม่สำเร็จ';
                this.status_loading = 3;
                this.showLoadingModal();
            })
        },
        deleteImportFactoryData(value) {
            if (value && this.delete_id) {
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                this.$store.dispatch("FactoryEmployeeImport/deleteFactoryEmployeeImport", this.delete_id).then(() => {
                    this.getFactoryImportTable(this.dataPaginate.current_page);
                    this.msg = 'ลบรายการสำเร็จ';
                    this.status_loading = 2;
                    this.showLoadingModal();
                }).catch(() => {
                    this.msg = 'ลบรายการไม่สำเร็จ';
                    this.status_loading = 3;
                    this.showLoadingModal();
                });
            }
            this.hideDeleteModal();
        },
        ImportFactoryItem(value) {
            if (value) {
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.showLoadingModal();
                let data = {
                    employee_id: value.employee_id,
                    date: value.date ? moment(value.date).format("YYYY-MM-DD") : '',
                    hr_factory_id: value.hr_factory_id,
                    quantity: value.quantity,
                    user_id: value.user_id
                }
                //console.log(data);
                this.$store.dispatch("FactoryEmployeeImport/saveFactoryEmployeeImport", {
                    id: value.id,
                    data,
                }).then(res => {
                    if (res) {
                        this.getFactoryImportTable(this.dataPaginate.current_page);
                        this.hideLoadingModal();
                    } else {
                        this.msg = 'นำออกสินค้าโรงงานไม่เสร็จ';
                        this.status_loading = 3;
                        this.showLoadingModal();
                    }
                }).catch(() => {
                    this.msg = 'นำออกสินค้าโรงงานไม่เสร็จ';
                    this.status_loading = 3;
                    this.showLoadingModal();
                })
            }
            this.hideImportItemModal();
        },
    },
}
</script>

<style scoped>

</style>
